import request from "@/http/request"; 



const url="NewsController"
/**
 * 创建新闻
 * @param news
 */
export function addNews(news) {
    return request({
        url: url+'/addNews',
        method: 'post',
        data: news
    });
}

/**
 * 获取所有新闻
 */
export function getAllNews(news) {
    return request({
      url: url + '/GetMyAllNews',
      method: 'post',
      data: news
    });
  }

 
/**
 * 获取相邻的新闻
 * @param id 当前新闻的ID
 * @param direction 方向，"prev"表示前一篇，"next"表示后一篇
 */
export function getAdjacentNews(params) {
    return request({
        url: url + '/getAdjacentNews',
        method: 'get',
        params:params
    });
}
 

/**
 * 更新新闻
 * @param news
 */
export function updateNews(news) {
    return request({
        url: url+'/updateNews',
        method: 'put',
        data: news
    });
}

/**
 * 删除新闻
 * @param id
 */
export function deleteNews(id) {
    return request({
        url: url+'/deleteNews', 
        method: 'delete',
        params: { id: id } // 使用 params 传递参数
    });
}


// WEBPACK FOOTER //
// ./src/api/news/newsInfo.js